import BaseModule from '@core/modules/base-module/base-module';


  const formsGroup=new BaseModule();
  formsGroup.name='forms-group';
  formsGroup.init();


